import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrSpPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_sp'
        title='Special terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'escrow', subNavType: 'escrow', subNavPage: 'sp' }}
      />
    )
  }
}

export default MasterLoanAgrSpPageSF
